import { render } from "./ChartsPage.vue?vue&type=template&id=6813a7e9&ts=true"
import script from "./ChartsPage.vue?vue&type=script&lang=ts"
export * from "./ChartsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__